import angular from "angular";
import _ from "lodash";

angular.module("webTools").service("Columns", [
  "$q",
  "$http",
  "$compile",
  "$rootScope",
  function ($q, $http, $compile, $rootScope) {
    var _defaultColumns = [];
    var _isUserView = false;

    var checkColumn = {
      hidden: false,
      field: "check",
      menu: false,
      sortable: false,
      title: " ",
      width: 50,
      resizable: false,
      reorderable: false,
      headerTemplate:
        '<div class="master-checkbox left" ng-click="check()"></div>',
      template: "<wt-checkbox></wt-checkbox>",
    };

    var checkColumnNoFolders = {
      hidden: false,
      field: "check",
      menu: false,
      sortable: false,
      title: " ",
      width: 50,
      resizable: false,
      reorderable: false,
      template: '#if (Folder !== "0") {# <wt-checkbox></wt-checkbox> #}#'
    };

    var checkStarColumn = {
      hidden: false,
      field: "check-star",
      menu: false,
      sortable: false,
      title: " ",
      width: 75,
      resizable: false,
      reorderable: false,
      headerTemplate:
        '<div class="master-checkbox left" ng-click="check()"></div>',
      template:
        '# var lit = IsFavorite === "1" ? "star-lit" : "";#' +
        '# if (ObjectType !== "fod") { #<wt-checkbox></wt-checkbox><wt-star class="#=lit#"></wt-star>' +
        "#} else {#" +
        '<wt-star class="#=lit#"></wt-star>' +
        "#}#",
    };

    var statusColumn = {
      hidden: false,
      field: "status",
      menu: false,
      sortable: false,
      title: " ",
      width: 30,
      resizable: false,
      reorderable: false,
      template:
        '#var si = "";#' +
        "#var s = Status;#" +
        "#var a = Activity;#" +
        '#if(s === "Checked Out") {#' +
        '#si = a === "In Process" ? "check-cog" : "check";#' +
        "#} else {#" +
        '#if(s === "Approved") {#' +
        '#si = a === "In Process" ? "blue-yellow-cog" : "blue-cog";#' +
        "#} else {#" +
        '#if (a === "In Process") { si = "yellow-cog"; } }#' +
        "#}#" +
        '#if (si !== "") { #' +
        '<div><img src=/images/status/#=si#.png style="margin:-5px 5px -1px 1px;"/></div>' +
        "#}#",
    };

    var fileNameColumn = {
      hidden: false,
      menu: false,
      field: "FileName",
      title: "File Name",
      reorderable: true,
      template:
        '# if (ObjectType === "fod") { #' +
        '<div style="display:inline;">' +
        '<img width="24px" height="18px" style="float:left;display:inline-block;" src="/images/folder.png" />' +
        '<span class="folder-name" wt-folder-link>#=FileName.replace(/</g, "&lt").replace(/>/g, "&gt")#</span>' +
        "</div>" +
        "#} else {#" +
        '<div style="display:inline;">' +
        '<div style="cursor:pointer" class="file-icon-small files-small-#=ObjectType#" wt-view-file-link tooltip="Click to view"></div>' +
        '<span class="file-name" wt-grid-link>#=FileName.replace(/</g, "&lt").replace(/>/g, "&gt")##= ObjectType ? "." : "" ##=ObjectType#</span> ' +
        "</div>" +
        "#}#",
    };

    var subjectColumn = {
      hidden: false,
      menu: false,
      field: "Subject",
      title: "Subject",
      reorderable: true,
      template:
        '<img width="16px" height="18px" style="float:left;display:inline-block;" src="/images/icons/messages.png" />' +
        '# if (MessageRead === "1") { #' +
        '<div style="display:inline;">' +
        '<span class="file-name" style="" wt-grid-link>#=Subject.replace(/</g, "&lt").replace(/>/g, "&gt")#</span> ' +
        "</div>" +
        "#} else { #" +
        '<div style="display:inline;">' +
        '<span class="file-name bold" wt-grid-link>#=Subject.replace(/</g, "&lt").replace(/>/g, "&gt")#</span> ' +
        "</div>" +
        "#}#",
    };

    var instanceColumn = {
      hidden: false,
      menu: false,
      field: "InstanceName",
      title: "Instance Name",
      reorderable: true,
      template:
        '# var wf = angular.element("\\#container").scope().workingFolder; #' +
        '<img width="15px" height="18px" style="float:left;display:inline-block;" src="/images/icons/#=wf#.png" />' +
        '<div style="display:inline;">' +
        '<span class="file-name" style="" wt-grid-link>#=InstanceName.replace(/</g, "&lt").replace(/>/g, "&gt")#</span> ' +
        "</div>",
    };

    var projectColumn = {
      hidden: false,
      menu: false,
      field: "ProjectName",
      title: "Project Name",
      reorderable: true,
      template:
        '# var wf = Folder === "0" ? "folder.png" : "grid-icon.png"; #' +
        '<img style="float:left;display:inline-block;" src="/images/#=wf#" />' +
        '<div style="display:inline;">' +
        '#if(Folder === "0") {#' +
        '<span class="folder-name" style="" wt-folder-link>#=ProjectName#</span> ' +
        "#} else {#" +
        '<span class="file-name" style="" wt-project-link>#=ProjectName#</span> ' +
        "#}#" +
        "</div>",
    };

    var savedSearchColumn = {
      hidden: false,
      menu: false,
      field: "SearchName",
      title: "Search Name",
      reorderable: true,
      template:
        '# var wf = Folder === "0" ? "folder.png" : "/icons/search.png"; #' +
        '<img style="float:left;display:inline-block;" src="/images/#=wf#" />' +
        '<div style="display:inline;">' +
        '#if(Folder === "0") {#' +
        '<span class="folder-name" style="" wt-folder-link>#=SearchName#</span> ' +
        "#} else {#" +
        '<span class="file-name" style="" wt-search-link>#=SearchName#</span> ' +
        "#}#" +
        "</div>",
    };

    var getDefaultColumns = function (folderId, localColumns, viewType) {
      if (!viewType) {
        viewType = "";
      }

      var promise = $q.defer();
      if (!localColumns) {
        localColumns = [];
      }

      $http
        .post(`/api/columns/GetColumns`, {
          folderID: folderId,
          viewType: viewType,
        })
        .then(function (response) {
          let data = response.data;
          let defaultSort = [];

          _isUserView = data.IsUserView;

          var sort = '';
          var skipColumns = _.map(localColumns, "field");

          _.forEach(data.Columns, function (column) {
            if (_.includes(skipColumns, column.ColumnID)) {
              _.find(localColumns, { field: column.ColumnID }).width = parseInt(
                column.Width,
                10
              );
              return true;
            }

            if (column.ColumnID === "FileName") {
              fileNameColumn.width = parseInt(column.Width, 10) + 40;

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }

              localColumns.push(fileNameColumn);
            }
            else if (column.ColumnID === "InstanceName") {
              instanceColumn.width = parseInt(column.Width, 10) + 40;

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }

              if (folderId === "tasks" || folderId === "history") {
                localColumns.push(instanceColumn);
              }
            }
            else if (column.ColumnID === "ProjectName") {

              projectColumn.width = parseInt(column.Width, 10) + 40;

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }


              localColumns.push(projectColumn);
            }
            else if (column.ColumnID === "Subject") {

              subjectColumn.width = parseInt(column.Width, 10) + 40;

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }

              localColumns.push(subjectColumn);

            }
            else if (column.ColumnID === "SearchName") {

              savedSearchColumn.width = parseInt(column.Width, 10) + 40;

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }

              localColumns.push(savedSearchColumn);

            }
            else {
              var columnObject = {
                field: column.ColumnID,
                title: column.DisplayName.replace(/</g, "&lt;").replace(
                  />/g,
                  "&gt;"
                ),
                hidden: !column.Visible,
                width: parseInt(column.Width, 10) + 40,
              };

              if (column.Sort > 0 && column.Visible) {
                sort = column.Sort === 1 ? "asc" : "desc";
                defaultSort.push({ field: column.ColumnID, dir: sort });
              }

              localColumns.push(columnObject);
            }
          });

          localColumns.push({});
          localColumns.defaultSort = defaultSort;

          promise.resolve(localColumns);
        });

      return promise;
    };

    return {
      defaultColumns: function () {
        return _defaultColumns;
      },
      isUserView: function () {
        return _isUserView;
      },

      getDocumentColums: function (folderId, view, readOnly) {
        var localColumns = [];

        if (folderId === "recyclebin" || readOnly) {
          localColumns.push(checkColumn);
        } else {
          localColumns.push(checkStarColumn);
        }

        localColumns.push(statusColumn);

        return getDefaultColumns(folderId, localColumns, view);
      },

      getWorkflowColums: function (folderId) {
        folderId = folderId.toLowerCase();

        var localColumns = [];

        if (folderId === "messages") {
          localColumns.push(checkColumn);
        }

        return getDefaultColumns(folderId, localColumns);
      },

      getProjectColumns: function (folderId) {
        folderId = folderId.toLowerCase();

        var localColumns = [];
        localColumns.push(checkColumnNoFolders);

        return getDefaultColumns(folderId, localColumns, "Projects");
      },

      getProjectDocumentColums: function (folderId) {
        folderId = folderId.toLowerCase();

        var localColumns = [];

        localColumns.push(checkStarColumn);
        localColumns.push(statusColumn);

        return getDefaultColumns(folderId, localColumns, "Project Documents");
      },

      getSearchColumns: function (folderId) {
        folderId = folderId.toLowerCase();

        var localColumns = [];

        return getDefaultColumns(folderId, localColumns, "Searches");
      },

      saveColumns: function (columnArray, callback) {
        $http.post(`/api/columns/SaveColumns`, columnArray).then(function () {
          if (callback) {
            callback();
          }
        });
      },

      resetColumns: function (folderId, callback) {
        $http
          .get(`/api/columns/ResetColumns`, { params: { folderID: folderId } })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },

      addFavorite: function (objectId, callback) {
        $http
          .post(`/api/favorites/addfavorite`, { objectId: objectId })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },

      removeFavorite: function (objectId, callback) {
        $http
          .post(`/api/favorites/removefavorite`, { objectId: objectId })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },

      markRead: function (objectId, callback) {
        $http
          .post(`/api/messages/togglereadstate`, {
            MessageID: objectId,
            Action: "read",
          })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },

      markUnread: function (objectId, callback) {
        $http
          .post(`/api/messages/togglereadstate`, {
            MessageID: objectId,
            Action: "unread",
          })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },

      deleteMessage: function (objectId, callback) {
        $http
          .post(`/api/messages/deletemessages`, {
            MessageID: objectId,
            Action: "delete",
          })
          .then(function () {
            if (callback) {
              callback();
            }
          });
      },
    };
  },
]);
